module.exports = __webpack_public_path__ + "static/media/KUZMA CAR-30.ce7ee94b.png";